/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Analysis-page top-N stats tables and their column/top-N chrome.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {PopoverModule} from 'ngx-bootstrap/popover';

import {AppSharedModule} from '../app-shared.module';
import {ChartsModule} from '../directives/charts.module';
import {ColumnSelectorComponent} from './column-selector.component';
import {TopArticlesScreenshottingModalComponent} from './top-articles-screenshotting-modal.component';
import {TopArticlesTableComponent} from './top-articles-table.component';
import {TopDomainTableComponent} from './top-domain-table.component';
import {TopNSelectorComponent} from './top-n-selector.component';
import {TopStatsTableComponent} from './top-stats-table.component';
import {TopStatsTableHostComponent} from '../directives/top-stats-table-host.component';
import {TopTargetingTableComponent} from './top-targeting-table.component';

const STATS_TABLES = [
  ColumnSelectorComponent,
  TopNSelectorComponent,
  TopStatsTableComponent,
  TopStatsTableHostComponent,
  TopTargetingTableComponent,
  TopDomainTableComponent,
  TopArticlesTableComponent,
  TopArticlesScreenshottingModalComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    PopoverModule,
    ChartsModule
  ],
  declarations: STATS_TABLES,
  exports: STATS_TABLES
})
export class StatsTablesModule {
}
